import React from "react";
import { useParams } from "react-router-dom";
import Website from "./Website";

/**
 * WebsiteVersionView
 *
 * Read-only viewer for a specific website version (published OR draft), used by the
 * admin "view version" flow at `/view/:username/:domain/:version_slug`.
 *
 * It renders the standard <Website /> renderer with an explicit `version_slug`, which
 * makes it fetch that exact version via
 * `GET /api/websites/domain/<username>/<domain>/<version_slug>/`.
 *
 * Access control lives entirely on the backend: that endpoint only returns an
 * unpublished version to the owner or an authenticated admin. For everyone else it
 * responds 404, which <Website /> turns into the standard NotFoundWebsite page — so
 * non-admins opening a draft see exactly the same "not valid" result as before.
 */
const WebsiteVersionView = () => {
  const { username, domain, version_slug } = useParams();

  return <Website username={username} domain={domain} version_slug={version_slug} />;
};

export default WebsiteVersionView;
